import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ErrorService } from '../../services/error.service';
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  constructor(private errorService: ErrorService) { }

  public error: string;

  public icone = '&#128540;';

  public isLocal: boolean = environment.local;

  ngOnInit(): void {
    this.error = this.errorService.error;
  }

}
